import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import "./CancellationandRefundPolicy.css";
import { FaChevronUp } from "react-icons/fa6";
import { FaChevronDown } from "react-icons/fa";
const CancellationAndRefundPolicy = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const fben ={
    "1": "Cancellation and Refund Policy",
    "2": "Home"
  }
  const fbta ={
    "1": "ரத்துசெய்தல் மற்றும் பணத்தைத் திரும்பப்பெறுதல் கொள்கை",
    "2": "முகப்புப் பக்கம்"
  }
  const fbka ={
    "1": "ರದ್ದತಿ ಮತ್ತು ಮರುಪಾವತಿ ನೀತಿ",
    "2": "ಮರಳಿ ಪ್ರಥಮ ಪುಟಕ್ಕೆ"
  }
  
  const fbte ={
    "1": "రద్దు మరియు రీఫండ్ విధానం",
    "2": "హోం"
  }
  const fbhi = {
    "1": "रद्दीकरण और धनवापसी नीति",
    "2": "होम"
};
  const sectionshi = [
    {
        title: "आदेश रद्दीकरण",
        content: [
            "आप अपने आदेश को 24 घंटे के भीतर रद्द कर सकते हैं, बशर्ते कि आदेश को शिप नहीं किया गया हो।",
            "शिपिंग से पहले: अपने आदेश विवरण के साथ तुरंत हमसे support@terrainternational.in पर संपर्क करें।",
            "यदि आदेश अभी भी प्रोसेसिंग में है, तो हम इसे रद्द कर देंगे और पूरी धनवापसी जारी करेंगे।",
            "शिपिंग के बाद: पहले से शिप किए गए आदेशों को रद्द नहीं किया जा सकता। कृपया हमारी वापसी नीति देखें।"
        ]
    },
    {
        title: "धनवापसी",
        content: [
            "धनवापसी के लिए पात्रता:",
            "जो आदेश शिपिंग से पहले रद्द किए जाते हैं, उन्हें पूरी तरह से धनवापसी की जाएगी।",
            "यदि आपको कोई क्षतिग्रस्त, दोषपूर्ण या गलत उत्पाद प्राप्त होता है, तो आप डिलीवरी के 7-10 दिनों के भीतर धनवापसी का अनुरोध कर सकते हैं।",
            "धनवापसी मूल भुगतान विधि में की जाती है और इसमें 7-10 कार्यदिवस लग सकते हैं।"
        ]
    },
    {
        title: "वापसी नीति",
        content: [
            "यदि आप अपनी खरीद से संतुष्ट नहीं हैं, तो आप निम्नलिखित शर्तों के तहत डिलीवरी के 3 दिनों के भीतर उत्पाद लौटा सकते हैं:",
            "उत्पाद अप्रयुक्त और अपनी मूल स्थिति में है, जिसमें सभी पैकेजिंग बरकरार हो।",
            "डिलीवरी के 2 दिनों के भीतर वापसी अनुरोध किया गया हो।",
            "वापसी शुरू करने के लिए, support@terrainternational.in पर निर्देशों के लिए संपर्क करें।"
        ]
    },
    {
        title: "क्षतिग्रस्त या दोषपूर्ण उत्पाद",
        content: [
            "डिलीवरी के 24 घंटे के भीतर हमसे संपर्क करें और उत्पाद व पैकेजिंग की एक फोटो प्रदान करें।",
            "हम बिना किसी अतिरिक्त शुल्क के वापसी या एक्सचेंज की व्यवस्था करेंगे।",
            "यदि उत्पाद को प्रतिस्थापित नहीं किया जा सकता, तो हम पूरी धनवापसी जारी करेंगे।"
        ]
    },
    {
        title: "धनवापसी प्रक्रिया",
        content: [
            "रद्दीकरण या वापसी अनुरोध स्वीकृत होने के बाद, हम आपकी धनवापसी 7-10 कार्यदिवस के भीतर प्रोसेस करेंगे।",
            "धनवापसी मूल भुगतान विधि में की जाएगी।",
            "आपके भुगतान प्रदाता के आधार पर, धनवापसी को आपके खाते में प्रतिबिंबित होने में 7-10 कार्यदिवस लग सकते हैं।"
        ]
    },
    {
        title: "आदेश संशोधन",
        content: [
            "यदि आप अपने आदेश (जैसे उत्पाद या पते में बदलाव) को संशोधित करना चाहते हैं, तो कृपया तुरंत हमसे संपर्क करें।",
            "संशोधन केवल तभी किए जा सकते हैं जब आदेश को प्रोसेस या शिप नहीं किया गया हो।"
        ]
    },
    {
        title: "हमसे संपर्क करें",
        content: [
            "रद्दीकरण, वापसी, या धनवापसी से संबंधित किसी भी प्रश्न या सहायता के लिए हमसे संपर्क करें:",
            "ईमेल: support@terrainternational.in",
            "फोन: 7022519222"
        ]
    }
];
const sectionsta = [
  {
    title: "ஆர்டர் ரத்துசெய்தல்", content: [
      "ஆர்டர் அனுப்பப்படவில்லை என்றால், உங்கள் ஆர்டரை செய்த 24 மணி நேரத்திற்குள் அதை ரத்து செய்யலாம். அனுப்புவதற்கு முன்: உங்கள் ஆர்டர் விவரங்களுடன் support@terrainternational.in என்ற முகவரியில் உடனடியாக எங்களைத் தொடர்பு கொள்ளவும். ஆர்டர் இன்னும் செயல்பாட்டில் இருந்தால், நாங்கள் அதை ரத்துசெய்து முழு பணத்தையும் திரும்பப் பெறுவோம். அனுப்பிய பிறகு: ஏற்கனவே அனுப்பப்பட்ட ஆர்டர்களை ரத்து செய்ய முடியாது. எங்கள் திரும்பப் பெறும் கொள்கையைப் பார்க்கவும்."
    ]
  },
  {
    title: "பணத்தைத் திரும்பப் பெறுதல்", content: [
      "பணத்தைத் திரும்பப் பெறுவதற்கான தகுதி: அனுப்புவதற்கு முன்பு ரத்து செய்யப்பட்ட ஆர்டர்களுக்கு முழுமையாகத் திரும்பப் பெறப்படும். சேதமடைந்த, குறைபாடுள்ள அல்லது தவறான தயாரிப்பைப் பெற்றால், டெலிவரி செய்யப்பட்ட 7-10 நாட்களுக்குள் பணத்தைத் திரும்பப் பெறக் கோரலாம். பணத்தைத் திரும்பப் பெறுவது அசல் கட்டண முறையிலேயே செயல்படுத்தப்படும், மேலும் 7-10 வணிக நாட்கள் ஆகலாம்."
    ]
  },
  {
    title: "திரும்பும் கொள்கை", content: [
      "உங்கள் கொள்முதலில் நீங்கள் திருப்தி அடையவில்லை என்றால், பின்வரும் நிபந்தனைகளின் கீழ் டெலிவரி செய்யப்பட்ட 3 நாட்களுக்குள் தயாரிப்பைத் திருப்பித் தரலாம்: தயாரிப்பு பயன்படுத்தப்படவில்லை மற்றும் அனைத்து பேக்கேஜிங்களும் அப்படியே உள்ளன. டெலிவரி செய்யப்பட்ட 2 நாட்களுக்குள் திருப்பி அனுப்ப கோரிக்கை விடுக்கப்படுகிறது. திரும்பப் பெறத் தொடங்க, வழிமுறைகளுக்கு support@terrainternational.in என்ற முகவரியைத் தொடர்பு கொள்ளவும்."
    ]
  },
  {
    title: "சேதமடைந்த அல்லது குறைபாடுள்ள தயாரிப்புகள்", content: [
      "டெலிவரி செய்யப்பட்ட 24 மணி நேரத்திற்குள் எங்களைத் தொடர்பு கொண்டு, தயாரிப்பு மற்றும் பேக்கேஜிங்கின் புகைப்படத்தை வழங்கவும். கூடுதல் செலவு இல்லாமல் திருப்பி அனுப்ப அல்லது மாற்ற நாங்கள் ஏற்பாடு செய்வோம். தயாரிப்பை மாற்ற முடியாவிட்டால், முழுப் பணத்தையும் நாங்கள் திரும்பப் பெறுவோம்."
    ]
  },
  {
    title: "பணத்தைத் திரும்பப் பெறும் செயல்முறை", content: [
      "ரத்துசெய்தல் அல்லது திருப்பி அனுப்புதல் கோரிக்கை அங்கீகரிக்கப்பட்ட பிறகு, உங்கள் பணத்தைத் திரும்பப்பெறுவதை 7-10 வணிக நாட்களுக்குள் நாங்கள் செயல்படுத்துவோம். அசல் கட்டண முறைக்கு பணம் திரும்பப் பெறப்படும். உங்கள் கட்டண வழங்குநரைப் பொறுத்து, பணத்தைத் திரும்பப்பெறுதல் உங்கள் கணக்கில் பிரதிபலிக்க 7-10 வணிக நாட்கள் ஆகலாம்."
    ]
  },
  {
    title: "ஆர்டர் மாற்றங்கள்", content: [
      "உங்கள் ஆர்டரை மாற்ற விரும்பினால் (எ.கா. தயாரிப்பு அல்லது முகவரியை மாற்றவும்), உடனடியாக எங்களைத் தொடர்பு கொள்ளவும். ஆர்டர் செயல்படுத்தப்படாமலோ அல்லது அனுப்பப்படாமலோ இருந்தால் மட்டுமே மாற்றங்களைச் செய்ய முடியும்."
    ]
  },
  {
    title: "எங்களை தொடர்பு கொள்ள", content: [
      "ரத்துசெய்தல், திருப்பி அனுப்புதல் அல்லது பணத்தைத் திரும்பப் பெறுதல் தொடர்பான ஏதேனும் கேள்விகள் அல்லது உதவிக்கு, எங்களைத் தொடர்பு கொள்ளவும்: மின்னஞ்சல்: support@terrainternational.in தொலைபேசி: 7022519222"
    ]
  }
];
  const sectionsen = [
    {
      title: "Order Cancellation", content: [
        "You can cancel your order within 24 hours of placing it, provided the order has not been shipped.",
        "Before Shipping: Contact us immediately at support@terrainternational.in with your order details.",
        "If the order is still in processing, we will cancel it and issue a full refund.",
        "After Shipping: Orders that have already been shipped cannot be cancelled. Please refer to our Return Policy."
      ]
    },
    {
      title: "Refunds", content: [
        "Eligibility for Refund:",
        "Orders that are cancelled before shipping will be fully refunded.",
        "If you receive a damaged, defective, or incorrect product, you may request a refund within 7-10 days of delivery.",
        "Refunds are processed to the original payment method and may take 7-10 business days."
      ]
    },
    {
      title: "Return Policy", content: [
        "If you are not satisfied with your purchase, you may return the product within 3 days of delivery under the following conditions:",
        "The product is unused and in its original condition with all packaging intact.",
        "The return request is made within 2 days after delivery.",
        "To initiate a return, contact support@terrainternational.in for instructions."
      ]
    },
    {
      title: "Damaged or Defective Products", content: [
        "Contact us within 24 hours of delivery and provide a photo of the product and packaging.",
        "We will arrange for a return or exchange at no extra cost.",
        "If the product cannot be replaced, we will issue a full refund."
      ]
    },
    {
      title: "Refund Process", content: [
        "After the cancellation or return request is approved, we will process your refund within 7-10 business days.",
        "Refunds will be made to the original payment method.",
        "It may take 7-10 business days for the refund to reflect in your account depending on your payment provider."
      ]
    },
    {
      title: "Order Modifications", content: [
        "If you wish to modify your order (e.g., change the product or address), please contact us immediately.",
        "Modifications can only be made if the order has not been processed or shipped."
      ]
    },
    {
      title: "Contact Us", content: [
        "For any questions or assistance with cancellations, returns, or refunds, contact us:  ",
        "Email: support@terrainternational.in  ",
        "Phone: 7022519222"
      ]
    }
  ];
  const sectionska = [
    {
      title: "ಆರ್ಡರ್ ರದ್ದತಿ", content: [
        "ನೀವು ನಿಮ್ಮ ಆರ್ಡರ್ ಅನ್ನು 24 ಗಂಟೆಗಳೊಳಗೆ ರದ್ದುಗೊಳಿಸಬಹುದು, ಆದರೂ ಅದು ಇನ್ನೂ ರವಾನೆಯಾಗದಿದ್ದರೆ ಮಾತ್ರ.",
        "ರವಾನೆಯ ಮುನ್ನ: ನಿಮ್ಮ ಆರ್ಡರ್ ವಿವರಗಳೊಂದಿಗೆ support@terrainternational.in ಅನ್ನು ತಕ್ಷಣ ಸಂಪರ್ಕಿಸಿ.",
        "ಆರ್ಡರ್ ಇನ್ನೂ ಪ್ರಕ್ರಿಯೆಯಲ್ಲಿ ಇದ್ದರೆ, ಅದನ್ನು ರದ್ದುಗೊಳಿಸಲಾಗುತ್ತದೆ ಮತ್ತು ಪೂರ್ಣ ಮೊತ್ತ ಮರಳಿಸಲಾಗುತ್ತದೆ.",
        "ರವಾನೆಯ ನಂತರ: ಈಗಾಗಲೇ ರವಾನೆಯಾದ ಆರ್ಡರ್‌ಗಳನ್ನು ರದ್ದುಗೊಳಿಸಲಾಗುವುದಿಲ್ಲ. ದಯವಿಟ್ಟು ನಮ್ಮ ಮರುಪಾವತಿ ನೀತಿಯನ್ನು ನೋಡಿ."
      ]
    },
    {
      title: "ಪಾವತಿ", content: [
        "ಪಾವತಿಗೆ ಅರ್ಹತೆ:",
        "ರವಾನೆಯ ಮುನ್ನ ರದ್ದುಗೊಳಿಸಿದ ಆರ್ಡರ್‌ಗಳಿಗೆ ಸಂಪೂರ್ಣ ಪಾವತಿ ಮರಳಿಸಲಾಗುತ್ತದೆ.",
        "ನೀವು ಹಾನಿಗೊಂಡ, ಹಾಳಾದ, ಅಥವಾ ತಪ್ಪಾದ ಉತ್ಪನ್ನವನ್ನು ಪಡೆದರೆ, 7-10 ದಿನಗಳೊಳಗೆ ಮರುಪಾವತಿಗಾಗಿ ವಿನಂತಿಸಬಹುದು.",
        "ಮರುಪಾವತಿ ಮೂಲ ಪಾವತಿ ವಿಧಾನಕ್ಕೆ ಮಾಡಲಾಗುತ್ತದೆ ಮತ್ತು 7-10 ಕಾರ್ಯದಿನಗಳನ್ನ ತೆಗೆದುಕೊಳ್ಳಬಹುದು."
      ]
    },
    {
      title: "ಮರುಪಾವತಿ ನೀತಿ", content: [
        "ನೀವು ನಿಮ್ಮ ಖರೀದಿಯಿಂದ ತೃಪ್ತರಾಗದಿದ್ದರೆ, 3 ದಿನಗಳೊಳಗೆ ಮರುಪಾವತಿ ಮಾಡಬಹುದು, ಈ ನಿಯಮಗಳಂತೆ:",
        "ಉತ್ಪನ್ನವನ್ನು ಬಳಸದಿರಬೇಕು ಮತ್ತು ಎಲ್ಲಾ ಪ್ಯಾಕೇಜಿಂಗ್ ಸಹಿತ ಮೂಲ ಸ್ಥಿತಿಯಲ್ಲಿರಬೇಕು.",
        "ವಿತರಣೆಯ 2 ದಿನಗಳೊಳಗೆ ಮರುಪಾವತಿ ವಿನಂತಿ ಮಾಡಬೇಕು.",
        "ಮರುಪಾವತಿಯನ್ನು ಪ್ರಾರಂಭಿಸಲು, support@terrainternational.in ಗೆ ಸಂಪರ್ಕಿಸಿ."
      ]
    },
    {
      title: "ಹಾನಿಗೊಂಡ ಅಥವಾ ಹಾಳಾದ ಉತ್ಪನ್ನಗಳು", content: [
        "ವಿತರಣೆಯ 24 ಗಂಟೆಗಳೊಳಗೆ ನಮಗೆ ಸಂಪರ್ಕಿಸಿ ಮತ್ತು ಉತ್ಪನ್ನದ ಹಾಗೂ ಪ್ಯಾಕೇಜಿಂಗ್‌ನ ಫೋಟೋಗಳನ್ನು ಒದಗಿಸಿ.",
        "ನಾವು ಉಚಿತವಾಗಿ ಮರುಪಾವತಿ ಅಥವಾ ಬದಲಾವಣೆ ಮಾಡಿಸುತ್ತೇವೆ.",
        "ಉತ್ಪನ್ನವನ್ನು ಬದಲಾಯಿಸಲು ಸಾಧ್ಯವಾಗದಿದ್ದರೆ, ಪೂರ್ಣ ಮೊತ್ತ ಮರಳಿಸಲಾಗುತ್ತದೆ."
      ]
    },
    {
      title: "ಪಾವತಿ ಪ್ರಕ್ರಿಯೆ", content: [
        "ರದ್ದತಿ ಅಥವಾ ಮರುಪಾವತಿ ವಿನಂತಿಯನ್ನು ಅನುಮೋದಿಸಿದ ನಂತರ, ನಾವು ನಿಮ್ಮ ಪಾವತಿಯನ್ನು 7-10 ಕಾರ್ಯದಿನಗಳಲ್ಲಿ ಪ್ರಕ್ರಿಯೆಗೊಳಿಸುತ್ತೇವೆ.",
        "ಮರುಪಾವತಿ ಮೂಲ ಪಾವತಿ ವಿಧಾನಕ್ಕೆ ಮಾಡಲಾಗುತ್ತದೆ.",
        "ನಿಮ್ಮ ಪಾವತಿ ಪೂರೈಕೆದಾರರ ಪ್ರಕಾರ, ಪಾವತಿಯನ್ನು ನಿಮ್ಮ ಖಾತೆಗೆ ಹಿಂತಿರುಗಿಸಲು 7-10 ಕಾರ್ಯದಿನಗಳು ಹಿಡಿಯಬಹುದು."
      ]
    },
    {
      title: "ಆರ್ಡರ್ ತಿದ್ದುಪಡಿ", content: [
        "ನೀವು ನಿಮ್ಮ ಆರ್ಡರ್ ಅನ್ನು ಮಾರ್ಪಡಿಸಲು (ಉದಾ., ಉತ್ಪನ್ನ ಅಥವಾ ವಿಳಾಸ ಬದಲಾಯಿಸಲು) ಬಯಸಿದರೆ, ದಯವಿಟ್ಟು ತಕ್ಷಣ ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ.",
        "ಆರ್ಡರ್ ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗಿಲ್ಲದಿದ್ದರೆ ಅಥವಾ ರವಾನೆಯಾಗಿಲ್ಲದಿದ್ದರೆ ಮಾತ್ರ ತಿದ್ದುಪಡಿ ಮಾಡಬಹುದು."
      ]
    },
    {
      title: "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ", content: [
        "ರದ್ದತಿಗಳು, ಮರುಪಾವತಿ, ಅಥವಾ ಹಣ ಮರಳಿಸುವ ಬಗ್ಗೆ ಯಾವುದೇ ಪ್ರಶ್ನೆಗಳಿದ್ದರೆ, ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ:",
        "ಇಮೇಲ್: support@terrainternational.in",
        "ಫೋನ್: 7022519222"
      ]
    }
  ];
  const sectionste = [
    {
      title: "ఆర్డర్ రద్దు", content: [
        "మీరు మీ ఆర్డర్‌ను 24 గంటలలోగా రద్దు చేసుకోవచ్చు, కాని అది ఇంకా షిప్ చేయబడకపోతే మాత్రమే.",
        "షిప్పింగ్‌కు ముందు: మీ ఆర్డర్ వివరాలతో support@terrainternational.in ను వెంటనే సంప్రదించండి.",
        "ఆర్డర్ ఇంకా ప్రాసెసింగ్‌లో ఉంటే, మేము దానిని రద్దు చేసి పూర్తి రీఫండ్ ఇస్తాము.",
        "షిప్పింగ్ తర్వాత: ఇప్పటికే షిప్ చేయబడిన ఆర్డర్‌లను రద్దు చేయలేము. దయచేసి మా రిటర్న్ పాలసీని చూడండి."
      ]
    },
    {
      title: "రిఫండ్లు", content: [
        "రిఫండ్‌కు అర్హత:",
        "షిప్పింగ్‌కు ముందు రద్దు చేసిన ఆర్డర్‌లకు పూర్తి రీఫండ్ అందించబడుతుంది.",
        "మీరు దెబ్బతిన్న, లోపభూయిష్టమైన, లేదా తప్పుగా పంపబడిన ఉత్పత్తిని అందుకున్నట్లయితే, డెలివరీ అయిన 7-10 రోజుల్లో రీఫండ్ కోరవచ్చు.",
        "రిఫండ్లు అసలు చెల్లింపు పద్ధతికి చేయబడతాయి మరియు 7-10 వాణిజ్య రోజుల పాటు పడుతుంది."
      ]
    },
    {
      title: "రిటర్న్ పాలసీ", content: [
        "మీరు మీ కొనుగోలుతో సంతృప్తి చెందకపోతే, డెలివరీ అయిన 3 రోజుల్లో ఉత్పత్తిని తిరిగి ఇవ్వవచ్చు, కానీ ఈ షరతులతో:",
        "ఉత్పత్తి వాడకపోయి, అసలు ప్యాకేజింగ్‌తో ఉండాలి.",
        "రిటర్న్ అభ్యర్థనను డెలివరీ అయిన 2 రోజుల్లో చేయాలి.",
        "రిటర్న్ ప్రక్రియ ప్రారంభించడానికి support@terrainternational.in ను సంప్రదించండి."
      ]
    },
    {
      title: "నష్టపోయిన లేదా లోపభూయిష్ట ఉత్పత్తులు", content: [
        "డెలివరీ అయిన 24 గంటలలో మమ్మల్ని సంప్రదించి, ఉత్పత్తి మరియు ప్యాకేజింగ్ ఫోటోలను అందించండి.",
        "మేము ఉచితంగా రిటర్న్ లేదా మార్పిడిని ఏర్పాటుచేస్తాము.",
        "ఉత్పత్తి మార్పిడి చేయలేకపోతే, పూర్తి రీఫండ్ అందించబడుతుంది."
      ]
    },
    {
      title: "రిఫండ్ ప్రక్రియ", content: [
        "ఆర్డర్ రద్దు లేదా రిటర్న్ అభ్యర్థన ఆమోదించబడిన తర్వాత, మేము మీ రీఫండ్‌ను 7-10 వాణిజ్య రోజుల్లో ప్రాసెస్ చేస్తాము.",
        "రిఫండ్లు అసలు చెల్లింపు పద్ధతికి చేయబడతాయి.",
        "మీ చెల్లింపు ప్రొవైడర్‌పై ఆధారపడి, రీఫండ్ మీ ఖాతాలో ప్రతిబింబించడానికి 7-10 వాణిజ్య రోజులు పట్టవచ్చు."
      ]
    },
    {
      title: "ఆర్డర్ మార్పులు", content: [
        "మీరు మీ ఆర్డర్‌ను సవరించాలనుకుంటే (ఉదా., ఉత్పత్తి లేదా చిరునామా మార్చడం), వెంటనే మమ్మల్ని సంప్రదించండి.",
        "ఆర్డర్ ఇంకా ప్రాసెస్ చేయకపోతే లేదా షిప్ చేయకపోతే మాత్రమే మార్పులు చేయవచ్చు."
      ]
    },
    {
      title: "మమ్మల్ని సంప్రదించండి", content: [
        "రద్దు, రిటర్న్‌లు, లేదా రీఫండ్‌లకు సంబంధించిన ప్రశ్నల కోసం మమ్మల్ని సంప్రదించండి:",
        "ఇమెయిల్: support@terrainternational.in",
        "ఫోన్: 7022519222"
      ]
    }
  ];
  const [fb,setFB] =useState(fben)
  const [sections, setHomeen] = useState(sectionsen)

  useEffect(() => {
      const storedLanguage = localStorage.getItem("selectedLanguage") || "en";
  switch (storedLanguage) {
      case "kn":
          setHomeen(sectionska);
          setFB(fbka);
          break;
      case "te":
          setHomeen(sectionste);
          setFB(fbte);
          break;
      case "ta":
          setHomeen(sectionsta);
          setFB(fbta);
          break;
          case "hi":
            setHomeen(sectionshi);
            setFB(fbhi);
            break;
      default:
              setHomeen(sectionsen);
              setFB(fben);
  }

}, []);
  return (
    <>
      <div className="breadcrumb-wrap bg-f br-2">
        <div className="container">
        <div className="breadcrumb-title">
            <h2>{fb["1"]}</h2>
            <ul className="breadcrumb-menu list-style">
              <li><Link to="/">{fb["2"]}</Link></li>
              <li>{fb["1"]}</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="faqs-container">
        {sections.map((item, index) => (
          <div className="faq" key={index}>
            <h6 onClick={() => toggleFAQ(index)} className="faq-question">
              {item.title} {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
            </h6>
            <div className={`faq-answer ${openIndex === index ? "open" : ""}`}>
              {openIndex === index && item.content}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default CancellationAndRefundPolicy;
